// src/pages/BrandsList.jsx
import React, { useEffect, useState } from "react";
import { Table, Button, Typography, message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getBrands } from "../api/brandApi";
import CreateBrandForm from "./CreateBrandForm"; // Importa el formulario creado

const { Title } = Typography;

const BrandsList = () => {
  const [brands, setBrands] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();
  const { role } = useAuth(); // Obtenemos el rol del usuario actual

  // Verificamos que el usuario sea ADMIN
  useEffect(() => {
    if (role !== "ADMIN") {
      message.error("Acceso no autorizado");
      navigate("/");
    }
  }, [role, navigate]);

  const fetchBrands = async () => {
    try {
      const response = await getBrands();
      setBrands(response.data);
    } catch (error) {
      console.error("Error fetching brands:", error);
      message.error("Error al obtener las marcas");
    }
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleSuccess = () => {
    closeModal();
    fetchBrands(); // Refrescar la lista de marcas
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Marca",
      dataIndex: "name",
      key: "name",
    },
  ];

  return (
    <div
      style={{
        background: "#1f1f1f",
        color: "#ccc",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 10px rgba(0,0,0,0.5)",
        minHeight: "calc(100vh - 80px)",
      }}
    >
      <Title level={2} style={{ color: "#fff" }}>
        Listado de Marcas
      </Title>
      <Button type="primary" onClick={openModal} style={{ marginBottom: 16 }}>
        Crear Marca
      </Button>
      <Table
        columns={columns}
        dataSource={brands}
        rowKey="id"
        style={{
          background: "#2a2a2a",
          color: "#ccc",
        }}
      />

      <Modal
        title={<span style={{ color: "#fff" }}>Crear Marca</span>}
        open={modalVisible}
        onCancel={closeModal}
        footer={null}
        destroyOnClose
        bodyStyle={{ background: "#1f1f1f", color: "#ccc" }}
      >
        <CreateBrandForm onSuccess={handleSuccess} onCancel={closeModal} />
      </Modal>
    </div>
  );
};

export default BrandsList;
